
















































































import "vue-loading-overlay/dist/vue-loading.css";
import "flatpickr/dist/flatpickr.css";
import { Vue, Component } from "vue-property-decorator";
import QScripts from "@/common/qScripts.vue";

@Component({
  name: "QApp",
  components: {
    QScripts,
  }
})
export default class QApp extends Vue {
  // created(): void {
  //   store.dispatch("Auth/fetchCurrentUser");
  // },
};
